import { TypePolicy } from '@apollo/client';

const EncounterTaskAttachment: TypePolicy = {
  keyFields: ['encounterTaskAttachmentId'],
};

export default EncounterTaskAttachment;
